// import {store} from './Store/store'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import Login from '../components/CmpLogin/Login'
import WebsiteView from '../components/CmpLogin/WebsiteView'
// import AnvaHesab from '../components/MnuBasicInfo/CmpAnvaHesab/AnvaHesab'

import PishkhanNetPa from '../components/PishkhanNetPa'
import Maintenance from '../components/CmpNetPa/Maintenance.vue'
import Accounts from '../components/CmpNetPa/Accounts'
import NetpaHome from '../components/CmpNetPa/NetpaHome'
import PrintBargeSaham from '../components/CmpNetPa/PrintBargeSaham'
import loan from '../components/CmpNetPa/loan'
import Turnover from '../components/CmpNetPa/Turnover'
import Deposit from '../components/CmpNetPa/Deposit'
import Debtor from '../components/CmpNetPa/Debtor'
import Verify from '../components/CmpNetPa/Verify'
import LoanCardex from '../components/CmpNetPa/LoanCardex'
import DebtorReport from '../components/CmpNetPa/DebtorReport'
import UserInfo from '../components/CmpNetPa/UserInfo'
import Accessability from '../components/CmpNetPa/Accessability'
import MangeDownloadForms from '../components/CmpNetPa/ExtraFiles/MangeDownloadForms'
import ViewFiles from '../components/CmpNetPa/ExtraFiles/ViewFiles'
import SendFileToAdmin from '../components/CmpNetPa/SendFileToAdmin.vue'
import HampaPay from '../components/CmpNetPa/HampaPay'
import Rememberpassword from '../components/CmpNetPa/Rememberpassword'
import RememberPasswordHampa from '../components/CmpNetPa/RememberPasswordHampa'
import GuaranteeReport from '../components/CmpNetPa/GuaranteeReport'
import BlockedReport from '../components/CmpNetPa/BlockedReport'
import OnlinePaymentReport from '../components/CmpNetPa/OnlinePaymentReport'
import Gateway from '../components/CmpNetPa/Gateway'
import UsersSetting from '../components/CmpNetPa/UsersSetting'
import DepositGroup from '../components/CmpNetPa/DepositGroup'
import Cart from '../components/CmpNetPa/Cart'
import DepositWhithoutLogin from '../components/CmpNetPa/DepositWhithoutLogin'
import TablooElanat from '../components/CmpNetPa/TablooElanat'
import SendMessageToAdmin from '../components/CmpNetPa/SendMessageToAdmin'
import ManagUsers from '../components/CmpNetPa/ManagUsers'
import Register from '../components/CmpNetPa/Register'
import RegisterUser from '../components/CmpNetPa/Register'
import RequestVam from '../components/CmpNetPa/RequestVam'
import loanFollowup from '../components/CmpNetPa/loanFollowup'
import Transfer from '../components/CmpNetPa/Transfer'
import Cheque from '../components/CmpNetPa/Cheque'
import EstelamCheck from '../components/CmpNetPa/EstelamCheck'
import DetailUssd from '../components/CmpNetPa/DetailUssd'
import Transaction from '../components/CmpLogin/Transaction'
import PayStarTransaction from '../components/CmpLogin/PayStarTransaction'
import ZarinPalTransaction from '../components/CmpLogin/ZarinPalTransaction'
import ParsianTransaction from '../components/CmpLogin/ParsianTransaction'
import Funds from '../components/CmpNetPa/Funds.vue'
import SafteElectronic from '../components/CmpNetPa/FaraBoom/SafteElectronic.vue'
import VerifySafte from '../components/CmpNetPa/FaraBoom/VerifySafte.vue'
import WebSiteSetting from '../components/WebSiteSettingComponents/WebSiteSetting.vue'
import AboutUs from '../components/WebSiteSettingComponents/Page/AboutUs.vue'
import LinkPay from '../components/CmpLogin/linkpay'
import LinkPayTaahodat from '../components/CmpLogin/LinkPayTaahodat.vue'
import SettingVam from '../components/CmpNetPa/SettingVam'
import RequestVamNew from '../components/CmpNetPa/RequestVamNew'
import ListVamRequests from '../components/CmpNetPa/ListVamRequests.vue'
import ListRegisterRequests from '../components/CmpNetPa/ListRegisterRequests.vue'
import RegisterCheck from '../components/CmpNetPa/RegisterCheck.vue'
import RequestLetterEnseraf from '../components/CmpNetPa/RequestLetterEnseraf.vue'
import ListRequestLetterEnseraf from '../components/CmpNetPa/ListRequestLetterEnseraf.vue'
import RequestLetterSodorEsterdad from '../components/CmpNetPa/RequestLetterSodorEsterdad.vue'
import RequestLetterTaghirAghsat from '../components/CmpNetPa/RequestLetterTaghirAghsat.vue'
import RequestLetterTaghirModatSepordeh from '../components/CmpNetPa/RequestLetterTaghirModatSepordeh.vue'
import ListRequestLetterTaghirModatSepordeh from '../components/CmpNetPa/ListRequestLetterTaghirModatSepordeh.vue'
import ListRequestLetterSodorEsterdad from '../components/CmpNetPa/ListRequestLetterSodorEsterdad.vue'
import ListRequestLetterTaghirAghsat from '../components/CmpNetPa/ListRequestLetterTaghirAghsat.vue'
import ListAzaFile from '../components/CmpNetPa/ListAzaFile.vue'
import BillPayment from '../components/CmpNetPa/BillPayment.vue'
import GeneratorLinkPay from '../components/CmpNetPa/GeneratorLinkPay.vue'
import TurnoverPDF from '../components/CmpNetPa/TurnoverPDF.vue'
import LoanCalculate from '../components/CmpNetPa/LoanCalculate.vue'

var axios = require('axios')
var config = {
  method: 'GET',
  url: '/appSettings.json?nocache=123',
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
    'Content-Type': 'application/json',
  },
}

export const routes = [
  {
    path: '',
    component: Login,
    name: 'LoginPage',
    props: true,
    beforeEnter(to, from, next) {
      axios(config).then((result) => {
        var IsWebSiteView = result.data.WebSiteView

        if (IsWebSiteView) {
          if (Vue.prototype.$session.get('ForceLoginpage')) {
            next()
          } else {
            next('/Home')
          }
        } else {
          next()
        }
      })
    },
  },
  { path: '/Home', component: WebsiteView, name: 'WebsiteView' },
  { path: '/AboutUs', component: AboutUs, name: 'AboutUs' },
  { path: '/Maintenance', component: Maintenance, name: 'Maintenance' },
  { path: '/Transaction', component: Transaction, name: 'Transaction' },
  { path: '/PayStarTransaction', component: PayStarTransaction, name: 'PayStarTransaction' },
  { path: '/ZarinPalTransaction', component: ZarinPalTransaction, name: 'ZarinPalTransaction' },
  { path: '/ParsianTransaction', component: ParsianTransaction, name: 'ParsianTransaction' },  
  { path: '*', redirect: { name: 'LoginPage' } },

  {
    path: '/Verify/:Status',
    component: Verify,
    name: 'Verify',
    props: true,
    query: true,
  },
  
  { path: '/VerifySafte', component: VerifySafte, name: 'VerifySafte', props: true },

  {
    path: '/DetailUssd/:Status',
    component: DetailUssd,
    name: 'DetailUssd',
    props: true,
    query: true,
  },
  {
    path: '/HampaPay/:Status',
    component: HampaPay,
    name: 'HampaPay',
    props: true,
    query: true,
  },

  {
    path: '/PishkhanNetPa',
    component: PishkhanNetPa,
    name: 'PishkhanNetPa',
    meta: { requiresAuth: false },
    children: [
      {
        path: 'Accounts',
        component: Accounts,
        name: 'Accounts',
        beforeEnter(to, from, next) {
          if (from.name == 'Turnover' || from.name == 'Deposit') {
            if (Vue.prototype.$session.get('UserFromAccount')) {
              Vue.prototype.$session.set('UserFromAccount', [Vue.prototype.$session.get('UserFromAccount')[0], true])
            }
          }
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'Accounts')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next('/LoginPage')
          }
        },
      },

      {
        path: 'Funds',
        component: Funds,
        name: 'Funds',
        beforeEnter(to, from, next) {
          if (from.name == 'Turnover' || from.name == 'Deposit') {
            if (Vue.prototype.$session.get('UserFromAccount')) {
              Vue.prototype.$session.set('UserFromAccount', [Vue.prototype.$session.get('UserFromAccount')[0], true])
            }
          }
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'Funds')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next('/LoginPage')
          }
        },
      },

      { path: 'Home', component: NetpaHome, name: 'Home' },
      {
        path: 'LoanRequest',
        component: RequestVam,
        name: 'LoanRequest',
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'loanFollowup',
        component: loanFollowup,
        name: 'loanFollowup',
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'TablooElanat',
        component: TablooElanat,
        name: 'TablooElanat',
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'PrintBargeSaham',
        component: PrintBargeSaham,
        name: 'PrintBargeSaham',
        props: true,
        query: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'SendMessageToAdmin',
        component: SendMessageToAdmin,
        name: 'SendMessageToAdmin',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'loan',
        component: loan,
        name: 'loan',
        beforeEnter(to, from, next) {
          if (from.name == 'Turnover' || from.name == 'LoanCardex' || from.name == 'Deposit') {
            if (Vue.prototype.$session.get('UserFromLoan')) {
              Vue.prototype.$session.set('UserFromLoan', [Vue.prototype.$session.get('UserFromLoan')[0], true])
            }
          }

          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'loan')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      {
        path: 'Turnover',
        component: Turnover,
        name: 'Turnover',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'Deposit',
        component: Deposit,
        name: 'Deposit',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'ViewFiles',
        component: ViewFiles,
        name: 'ViewFiles',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'SendFileToAdmin',
        component: SendFileToAdmin,
        name: 'SendFileToAdmin',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'SafteElectronic',
        component: SafteElectronic,
        name: 'SafteElectronic',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'Debtor',
        component: Debtor,
        name: 'Debtor',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'Debtor')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'LoanCardex',
        component: LoanCardex,
        name: 'LoanCardex',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'LoanCardex')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'DebtorReport',
        component: DebtorReport,
        name: 'DebtorReport',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'DebtorReport')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'Transfer',
        component: Transfer,
        name: 'Transfer',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'Transfer')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'UserInfo',
        component: UserInfo,
        name: 'UserInfo',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'UserInfo')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next('/LoginPage')
          }
        },
      },
      {
        path: 'Accessability',
        component: Accessability,
        name: 'Accessability',
        props: true,
        beforeEnter(to, from, next) {
          // console.log("ISRAHBAR",Vue.prototype.$session.get('IsRahbar'));
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            if (Vue.prototype.$session.get('IsRahbar') == false) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'MangeDownloadForms',
        component: MangeDownloadForms,
        name: 'MangeDownloadForms',
        props: true,
        beforeEnter(to, from, next) {
          // console.log("ISRAHBAR",Vue.prototype.$session.get('IsRahbar'));
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            if (Vue.prototype.$session.get('IsRahbar') == false) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'WebSiteSetting',
        component: WebSiteSetting,
        name: 'WebSiteSetting',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            if (Vue.prototype.$session.get('IsRahbar') == false) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'Gateway',
        component: Gateway,
        name: 'Gateway',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            if (Vue.prototype.$session.get('IsRahbar') == false) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'SettingVam',
        component: SettingVam,
        name: 'SettingVam',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            if (Vue.prototype.$session.get('IsRahbar') == false) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'RequestVamNew',
        component: RequestVamNew,
        name: 'RequestVamNew',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/PishkhanNetPa/Home')
          }
        },
      },
      {
        path: 'ListVamRequests',
        component: ListVamRequests,
        name: 'ListVamRequests',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/PishkhanNetPa/Home')
          }
        },
      },
      {
        path: 'ListRegisterRequests',
        component: ListRegisterRequests,
        name: 'ListRegisterRequests',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next('/PishkhanNetPa/Home')
          }
        },
      },
      {
        path: 'UsersSetting',
        component: UsersSetting,
        name: 'UsersSetting',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            if (Vue.prototype.$session.get('IsRahbar') == false) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'GuaranteeReport',
        component: GuaranteeReport,
        name: 'GuaranteeReport',
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'GuaranteeReport')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'EstelamCheck',
        component: EstelamCheck,
        name: 'EstelamCheck',
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'EstelamCheck')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'BlockedReport',
        component: BlockedReport,
        name: 'BlockedReport',
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'BlockedReport')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'OnlinePaymentReport',
        component: OnlinePaymentReport,
        name: 'OnlinePaymentReport',
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'OnlinePaymentReport')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'DepositGroup',
        component: DepositGroup,
        name: 'DepositGroup',
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'DepositGroup')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'Cart',
        component: Cart,
        name: 'Cart',
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next()
          }
        },
      },
      {
        path: 'ManagUsers',
        component: ManagUsers,
        name: 'ManagUsers',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            if (Vue.prototype.$session.get('ModirShobe') == false) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'Cheque',
        component: Cheque,
        name: 'Cheque',
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next()
          }
        },
      },
      {
        path: 'RegisterUser',
        component: RegisterUser,
        name: 'RegisterUser',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'RegisterUser')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'RequestLetterEnseraf',
        component: RequestLetterEnseraf,
        name: 'RequestLetterEnseraf',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'RequestLetterEnseraf')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'RequestLetterSodorEsterdad',
        component: RequestLetterSodorEsterdad,
        name: 'RequestLetterSodorEsterdad',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'RequestLetterSodorEsterdad')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'RequestLetterTaghirAghsat',
        component: RequestLetterTaghirAghsat,
        name: 'RequestLetterTaghirAghsat',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'RequestLetterTaghirAghsat')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'RequestLetterTaghirModatSepordeh',
        component: RequestLetterTaghirModatSepordeh,
        name: 'RequestLetterTaghirModatSepordeh',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'RequestLetterTaghirModatSepordeh')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'LoanCalculate',
        component: LoanCalculate,
        name: 'LoanCalculate',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'LoanCalculate')
            if (access.length == 1) {
              if (!access[0].isMenu) {
                next('/PishkhanNetPa/Home')
              } else {
                next()
              }
            }
          } else {
            next()
          }
        },
      },
      {
        path: 'TurnoverPDF',
        component: TurnoverPDF,
        name: 'TurnoverPDF',
        props: true,
      },
      {
        path: 'ListRequestLetterTaghirModatSepordeh',
        component: ListRequestLetterTaghirModatSepordeh,
        name: 'ListRequestLetterTaghirModatSepordeh',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
            next()
          } else {
            next()
          }
        },
      },
      {
        path: 'ListRequestLetterEnseraf',
        component: ListRequestLetterEnseraf,
        name: 'ListRequestLetterEnseraf',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
                next()
              } else {
                next()
              }
        },
      },
      {
        path: 'ListRequestLetterSodorEsterdad',
        component: ListRequestLetterSodorEsterdad,
        name: 'ListRequestLetterSodorEsterdad',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
                next()
              } else {
                next()
              }
        },
      },
      {
        path: 'ListRequestLetterTaghirAghsat',
        component: ListRequestLetterTaghirAghsat,
        name: 'ListRequestLetterTaghirAghsat',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
                next()
              } else {
                next()
              }
        },
      },
      {
        path: 'ListAzaFile',
        component: ListAzaFile,
        name: 'ListAzaFile',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
                next()
              } else {
                next()
              }
        },
      },
      {
        path: 'BillPayment',
        component: BillPayment,
        name: 'BillPayment',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode') && Vue.prototype.$session.get('AccessMenu')) {
                next()
              } else {
                next('/PishkhanNetPa/Home')
              }
        },
      },
      {
        path: 'GeneratorLinkPay',
        component: GeneratorLinkPay,
        name: 'GeneratorLinkPay',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('CustCode')==866 || Vue.prototype.$session.get('CustCode')==8002) {
                next()
              } else {
                next('/PishkhanNetPa/Home')
              }
        },
      },
    ],
  },
  { path: '/Rememberpassword', component: Rememberpassword, name: 'Rememberpassword', meta: { requiresAuth: false } },
  { path: '/RememberPasswordHampa', component: RememberPasswordHampa, name: 'RememberPasswordHampa', meta: { requiresAuth: false } },
  { path: '/DepositWhithoutLogin', component: DepositWhithoutLogin, name: 'DepositWhithoutLogin', meta: { requiresAuth: false } },
  { path: '/Register', component: Register, name: 'Register',props: true, query: true,meta: { requiresAuth: false } },
  {
    path: '/RegisterCheck/:Status',
    component: RegisterCheck,
    name: 'RegisterCheck',
    props: true,
    query: true, meta: { requiresAuth: false }
  },
  { path: '/v', component: LinkPay, name: 'v', meta: { requiresAuth: false } },
  { path: '/L', component: LinkPayTaahodat, name: 'L', meta: { requiresAuth: false } },
]
// console.log(routes)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
